var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilForPopup({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 25,
    height: 26,
    rx: 12.5,
    fill: "#f5f5f5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3624 7.16667C16.0379 7.16564 15.7164 7.2291 15.4166 7.35338C15.1167 7.47765 14.8446 7.66026 14.6159 7.89059L7.84053 14.6654C7.75362 14.7525 7.69645 14.8648 7.6772 14.9863L7.17378 18.1584C7.15927 18.2494 7.16653 18.3426 7.19496 18.4302C7.22339 18.5179 7.27219 18.5976 7.33736 18.6628C7.40253 18.7279 7.48221 18.7767 7.56987 18.8052C7.65753 18.8336 7.75069 18.8408 7.8417 18.8263L11.0168 18.3229C11.1383 18.3037 11.2506 18.2465 11.3376 18.1596L18.1095 11.3842C18.455 11.0384 18.6902 10.5979 18.7853 10.1185C18.8804 9.63901 18.8312 9.14212 18.6438 8.69065C18.4565 8.23918 18.1395 7.8534 17.7329 7.58213C17.3263 7.31086 16.8483 7.16628 16.3595 7.16667H16.3624ZM10.6434 17.2L8.45012 17.55L8.80012 15.3584L13.6943 10.4637L15.5388 12.3082L10.6434 17.2ZM17.2847 10.5593L16.363 11.4833L14.5168 9.63709L15.439 8.71542C15.6874 8.47832 16.0176 8.34603 16.361 8.34603C16.7044 8.34603 17.0346 8.47832 17.2829 8.71542C17.4041 8.83645 17.5002 8.98017 17.5658 9.13836C17.6314 9.29656 17.6651 9.46613 17.6651 9.63738C17.6651 9.80863 17.6314 9.9782 17.5658 10.1364C17.5002 10.2946 17.4041 10.4383 17.2829 10.5593H17.2847Z",
    fill: "#8E8E93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilForPopup);
export default __webpack_public_path__ + "static/media/pencilForPopup.d78ab59507a1915a1f47c47ee98dc2bd.svg";
export { ForwardRef as ReactComponent };